import { ActionIcon, Tooltip } from '@mantine/core';
import { useFullscreenElement } from '@mantine/hooks';
import { IconArrowsMaximize, IconArrowsMinimize } from '@tabler/icons-react';

export interface FullscreenToggleButtonProps {
  target: HTMLDivElement | null;
}

export function FullscreenToggleButton({ target }: FullscreenToggleButtonProps) {
  const { toggle, fullscreen, ref } = useFullscreenElement();

  if (!target) {
    return null;
  }

  ref(target);

  return (
    <div className="fullscreen-toggle">
      <Tooltip label="Toggle fullscreen" position="left" withArrow>
        <ActionIcon color={fullscreen ? 'red' : 'blue'} ml="auto" onClick={toggle} size="md" variant="outline">
          {fullscreen ? <IconArrowsMinimize size={14} /> : <IconArrowsMaximize size={14} />}
        </ActionIcon>
      </Tooltip>
    </div>
  );
}
